<h5 class="text-xl font-semibold">Filtros</h5>
<div class="grid grid-cols-12 gap-5">
  @for (item of filtros; track $index) {
    @if (item.type == 'dropdown') {
      <ng-template
        *ngTemplateOutlet="dropdown; context: { $implicit: item }"
      ></ng-template>
    }
    @if (item.type == 'input') {
      <ng-template
        *ngTemplateOutlet="input; context: { $implicit: item }"
      ></ng-template>
    }
    @if (item.type == 'date') {
      <ng-template
        *ngTemplateOutlet="date; context: { $implicit: item }"
      ></ng-template>
    }
    @if (item.type == 'multiselect') {
      <ng-template
        *ngTemplateOutlet="multiselect; context: { $implicit: item }"
      ></ng-template>
    }
  }
  <div class="col-span-12 flex justify-end">
    <petrol-button variant="tertiary" (click)="clearFilters()">
      Limpiar filtros
    </petrol-button>
  </div>
</div>

<ng-template #dropdown let-i>
  <div class="lg:col-span-3 md:col-span-6 sm:col-span-12 col-span-12">
    <c-dropdown
      [etiqueta]="i.label"
      [id]="i.query"
      [(option)]="i.value"
      [placeholder]="i.placeholder"
      [options]="i.options"
      [propiedad]="i.property"
      [(option)]="i.value"
      [filtrar]="true"
      [limpiar]="!i.disable"
      [setFirstValue]="false"
      (optionChange)="
        changeInput(i.query, $event ? $event[i.searchProperty] : '')
      "
      [readonly]="i.disable"
    />
  </div>
</ng-template>

<ng-template #input let-i>
  <div class="lg:col-span-3 md:col-span-6 sm:col-span-12 col-span-12">
    <c-input
      [etiqueta]="i.label"
      [(valor)]="i.value"
      [tipo]="i.tipo"
      [id]="i.query"
      [placeholder]="i.placeholder"
      [(valor)]="i.value"
      (valorChange)="changeInput(i.query, $event)"
      [readonly]="i.disable"
    />
  </div>
</ng-template>

<ng-template #date let-i>
  <div class="lg:col-span-3 md:col-span-6 sm:col-span-12 col-span-12">
    <c-calendar
      [etiqueta]="i.label"
      [id]="i.query"
      [placeholder]="i.placeholder"
      [(valor)]="i.value"
      [showIcon]="true"
      [showClear]="!i.disable"
      [maxDate]="i.maxDate ?? maxFecha"
      (valorChange)="changeInput(i.query, $event)"
      [readonly]="i.disable"
    />
  </div>
</ng-template>

<ng-template #multiselect let-i>
  <div class="lg:col-span-3 md:col-span-6 sm:col-span-12 col-span-12">
    <c-dropdown
      [multiple]="true"
      [etiqueta]="i.label"
      [id]="i.query"
      [placeholder]="i.placeholder"
      [options]="i.options"
      [propiedad]="i.property"
      [(option)]="i.value"
      [setFirstValue]="false"
      [filtrar]="true"
      [limpiar]="!i.disable"
      (optionChange)="
        changeInput(
          i.query,
          $event ? returnMap($event, i.searchProperty) : '',
          i.showAlwaysValues,
          i.options,
          i.searchProperty
        )
      "
      [readonly]="i.disable"
    />
  </div>
</ng-template>
